module.exports = __webpack_public_path__ + "media/images/server_error-5ea092a6.svg";